import type { RestaurantProductImpressionCategory } from 'root/core/lsVisitor.types';
import { restaurantProductImpressionCategories } from 'root/core/lsVisitor.types';
import { LsVisitor } from 'root/core/lsVisitor';
import restaurantProductClickTrackingData from 'root/core/restaurantProductTracking/restaurantProductClickTrackingData.json';

const restaurantProductTrackingIsEnabled =
    document.body.dataset.restaurantProductTracking === 'enabled';

/*
    An element (doesn't need to be visible, could even be on the body tag) that would set the product on load could look like this:
        <div data-ls-visitor-restaurant-product='{"impressionCategory":"URLContains","series":"gastrofix"}'></div>
*/
const trackRestaurantProductOnLoadViaDataAttribute = () => {
    if (restaurantProductTrackingIsEnabled) {
        const elementsToTrack = document.querySelectorAll<HTMLElement>(
            '[data-ls-visitor-restaurant-product]'
        );
        if (elementsToTrack.length > 0) {
            const lsv = new LsVisitor();
            for (const element of elementsToTrack) {
                const dataAttr = element.dataset.lsVisitorRestaurantProduct;
                const { impressionCategory, series } = dataAttr
                    ? JSON.parse(dataAttr)
                    : null;
                if (
                    impressionCategory &&
                    series &&
                    restaurantProductImpressionCategories.includes(impressionCategory)
                ) {
                    window.addEventListener('load', () => {
                        lsv.setRestaurantProductImpression(
                            impressionCategory as RestaurantProductImpressionCategory,
                            series
                        );
                    });
                }
            }
        }
    }
};

const trackRestaurantProductInURL = () => {
    if (restaurantProductTrackingIsEnabled) {
        const URLPath = window.location.pathname;
        if (URLPath.includes('/gastrofix/')) {
            const lsv = new LsVisitor();
            lsv.setRestaurantProductImpression('URLContains', 'gastrofix');
        }
    }
};

const trackRestaurantProductIfLinkMatchesHrefSubstring = (link: HTMLAnchorElement) => {
    if (restaurantProductTrackingIsEnabled && link instanceof HTMLAnchorElement) {
        for (const [
            hrefSubstring,
            impressionCategory,
            series,
        ] of restaurantProductClickTrackingData) {
            if (
                hrefSubstring &&
                impressionCategory &&
                series &&
                link.href.includes(hrefSubstring) &&
                restaurantProductImpressionCategories.includes(
                    impressionCategory as RestaurantProductImpressionCategory
                )
            ) {
                const lsv = new LsVisitor();
                lsv.setRestaurantProductImpression(
                    impressionCategory as RestaurantProductImpressionCategory,
                    series
                );
            }
        }
    }
};

const setRestaurantProductInHiddenFormField = (form: HTMLFormElement) => {
    const possibleFormSubstringsArray = ['restaurant', 'resto', 'other'];
    const isRestaurantForm = possibleFormSubstringsArray.some(substr => {
        return form.dataset.formName ? form.dataset.formName.includes(substr) : false;
    });
    if (restaurantProductTrackingIsEnabled && isRestaurantForm) {
        const lsv = new LsVisitor();
        const seriesHiddenField = form.querySelector<HTMLInputElement>(
            'input[type="hidden"][name="series"]'
        );
        if (seriesHiddenField) {
            seriesHiddenField.value = lsv.getRestaurantProduct();
        }
    }
};

export {
    trackRestaurantProductOnLoadViaDataAttribute,
    trackRestaurantProductInURL,
    trackRestaurantProductIfLinkMatchesHrefSubstring,
    setRestaurantProductInHiddenFormField,
};
